
import { Options, Vue } from "vue-class-component"; //基本需要
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1

// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class ReportList extends Vue {
  //渲染对象
  public object = {
    name: "菜鸟教程",
    url: "http://www.runoob.com",
    slogan: "学的不仅是技术，更是梦想！",
  };

  public Aarray1 = {
    dataA: {
      A: { a: 1, b: 2, c: 3 },
      B: { a: 1, b: 2, c: 3 },
      C: { a: 1, b: 2, c: 3 },
    },
    dataB: {
      A: { a: 5, b: 3, c: 4 },
      B: { a: 1, b: 4, c: 3 },
      C: { a: 1, b: 2, c: 8 },
    },
  };
  public dataa = ["2档机(oppo)", "2档机(oppo)", "2档机(oppo)"];
  public datab = [4, 5, 6];

  public domainName = window.parent.location.href; //获取域名

  // public threshold2 = [
  //   {
  //     scene: "场景一",
  //     device: "A机",
  //     row: "指标一",
  //     thresholdValue: "增长",
  //   },
  //   {
  //     scene: "场景一",
  //     device: "A机",
  //     row: "指标二",
  //     thresholdValue: "降低",
  //   },
  //   {
  //     scene: "场景二",
  //     device: "A机",
  //     row: "指标二",
  //     thresholdValue: "降低",
  //   },
  //   {
  //     scene: "场景二",
  //     device: "B机",
  //     row: "指标三",
  //     thresholdValue: "增长",
  //   }
  // ]

  public obj: any = { 未完成: 5, 已完成: 8, 待确认: 4, 已取消: 6 };
  public arr: any = [];
  public arr2: any = [
    { 未完成: 5 },
    { 已完成: 8 },
    { 待确认: 4 },
    { 已取消: 6 },
  ];
  public async mounted() {
    // console.log(this.domainName);//域名
    this.getNewAarray();
    await this.init();
    // this.getNew()
  }

  public getNewAarray() {
    for (let i in this.obj) {
      // this.arr.push(this.obj[i]); //属性 [5、8、4、6]
      let o: any = {};
      o[i] = this.obj[i];
      this.arr.push(o);
    }
  }
  public arrValue: any = [
    { 未完成: 5, 已完成: 8, 待确认: 4, 已取消: 6 },
    { 未完成: 1, 已完成: 8, 待确认: 3, 已取消: 6 },
    { 未完成: 2, 已完成: 8, 待确认: 8, 已取消: 6 },
    { 未完成: 3, 已完成: 8, 待确认: 8, 已取消: 6 },
  ];
  public arrValue2: any = [5, 1, 2];
  public ruleForm = {
    name: "",
    region: "",
    date1: "",
    date2: "",
    delivery: false,
    type: [],
    resource: "",
    desc: "",
  };

  // 多选数据
  public isIndeterminate = false;
  public checkAll = false;
  public checked: any[] = [];
  public checkedId: any[] = [];
  public checkedList = [
    {
      id: 1,
      name: "张三",
      phone: "13554006475",
    },
    {
      id: 2,
      name: "李四",
      phone: "13514002475",
    },
    {
      id: 3,
      name: "王五",
      phone: "13558992475",
    },
  ];
  public init() {
    for (let i = 0; i < this.checkedList.length; i++) {
      this.checkedId.push(this.checkedList[i].id);
    }
  }
  public handleCheckAllChange(val: any) {
    this.checked = val ? this.checkedId : [];
    this.isIndeterminate = false;
  }
  public handleCheckOtherChange(value: any) {
    let checkedCount = value.length;
    this.checkAll = checkedCount === this.checkedList.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.checkedList.length;
  }
  public resetForm(formName: any) {
    (this.$refs[formName] as any).resetFields();
  }
}
